import update from 'immutability-helper';
import PropTypes from 'prop-types';
import React from 'react';
import { DropTarget } from 'react-dnd';
import { PlaylistItem } from '..';
import PlaylistItemEdit from './main'
import { Box } from '../layout';
import Button from '../widgets/Button';

class PlaylistView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...props.playlist };
  }

  static propTypes = {
    playlist: PropTypes.object.isRequired,
    bulkEdit: PropTypes.bool,
    onReorder: PropTypes.func.isRequired,
    onReposition: PropTypes.func.isRequired,
    onDeletePlaylistItem: PropTypes.func.isRequired,
    onBulkDeletePlaylistItems: PropTypes.func.isRequired,
    onUpdatePlaylistItem: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    adding: PropTypes.bool.isRequired,
  };

  handleBulkDelete = () => {
    this.props.onBulkDeletePlaylistItems(this.state.items.filter(item => item.selected));
  }

  handleDrop = () => {
    this.props.onReorder(this.state);
  }

  handleOrderSave = () => {
    this.props.onReposition(this.state);
  }

  handleSelectItem = (item) => {

  }


  handlePositionChange = (id, position) => {
    this.setState(update(this.state, {
      items: {
        $apply: items => items.map(item => item.id === id ? { ...item, position: position } : item),
      },
    }));
  }

  handleSelectPlaylistItem = (item) => {
    const stateItem = this.state.items.find(i => i.id === item.id);


    stateItem.selected = !stateItem.selected;
  }

  moveItem = (dragIndex, hoverIndex) => {
    const playlist = this.state;
    const dragItem = playlist.items[dragIndex];

    this.setState(update(this.state, {
      items: {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragItem],
        ],
      },
    }));
  }

  componentWillReceiveProps(newProps) {
    if (this.props.playlist.items.length !== newProps.playlist.items.length) {
      this.setState({ ...newProps.playlist });
    }
  }

  render() {
    const playlist = this.state;
    const { connectDropTarget, adding } = this.props;

    return connectDropTarget(
      <div>
        {/* {this.saveDeleteComponent()} */}
        {adding ? <div className="dropspace" style={{
          width: '100%',
          height: 100,
          border: 'thin dashed grey',
        }}>
          Drop items here
        </div> : null}


        <PlaylistItemEdit
          adding={this.props.adding}
          replacing={this.props.replacing}
          items={playlist.items}
          playlist={this.props.playlist}
          handleSubscriptionChange={this.props.handleSubscriptionChange}
          editMode={this.props.bulkEdit}
          onChange={this.props.onUpdatePlaylistItem}
          onDelete={this.props.onDeletePlaylistItem}
          onPositionChange={this.handlePositionChange}
          onSelect={this.handleSelectPlaylistItem}
          handleOrderSave={this.handleOrderSave}
          moveItem={this.moveItem}
          sortType={this.props.itemType}
          onAssetChange={this.props.onAssetChange}
          handleSelectionOn={this.props.onSelectionON}
          selectionMain={this.props.selection}
          showThumbnails={this.props.showThumbnails}
          showThumbnailsState={this.props.showThumbnailsState}
          sortState={this.props.sortState}
          handleSwitchItemType={this.props.handleSwitchItemType}
          handleSortType={this.props.handleSortType}
          filterOptionsEnabled={this.props.filterOptionsEnabled}
          onReorder={this.props.onReorder}
          reportActivityStatus={this.props.reportActivityStatus}
          handleUserReport={this.props.handleUserReport}
          editPostion={this.props.editPostion}
          dropItem={this.handleDrop} 
          isTimedPlayback={this.props.isTimedPlayback}
          />

        {this.saveDeleteComponent()}
      </div>,
    );
  }

  saveDeleteComponent() {
    if (this.props.editPostion) {
      return (
        <Box direction="row" className="button-group">
          <Button onClick={this.handleOrderSave}>Save New Positions</Button>
        </Box>
      );
    }
  }
}

const AssetTarget = {
  drop(props, monitor) {
    props.onDrop(monitor.getItem());
  },
};

const makeTarget = DropTarget('ASSET_TYPE', AssetTarget, (connect) => ({
  connectDropTarget: connect.dropTarget(),
}));

export default makeTarget(PlaylistView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PlaylistView/index.js